import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26cf5cda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "complaints" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))
const _hoisted_5 = { class: "complaints__filters__inputs" }
const _hoisted_6 = { class: "flex items-center justify-end mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_complaint_form = _resolveComponent("complaint-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.form_state.is_opened)
      ? (_openBlock(), _createBlock(_component_complaint_form, {
          key: 0,
          "complaint-id": _ctx.form_state.complaint_id,
          onRefresh: _ctx.closeComplaintForm
        }, null, 8, ["complaint-id", "onRefresh"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_page_title, { title: "Жалобы" }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_the_button, {
                disabled: _ctx.state.is_excel_loading,
                loading: _ctx.state.is_excel_loading,
                hint: "Скачать Excel",
                class: "primary small mr-3",
                onClick: _ctx.exportExcel
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"]),
              _createVNode(_component_the_button, {
                class: "primary small",
                onClick: _ctx.onAddComplaint
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить жалобу ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("form", {
            class: "complaints__filters",
            onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.loadComplaints(1)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "w-full",
                placeholder: "Тип жалобы",
                options: _ctx.COMPLAINT_TYPES,
                value: _ctx.filters_state.typeId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.typeId) = $event))
              }, null, 8, ["options", "value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "w-full",
                placeholder: "Статус жалобы",
                options: _ctx.COMPLAINT_STATUSES,
                value: _ctx.filters_state.statusId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.statusId) = $event))
              }, null, 8, ["options", "value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                placeholder: "Ответственный отдел",
                loading: _ctx.state.departments.is_loading,
                failed: _ctx.state.departments.is_failed,
                "error-text": "При получении списка произошла ошибка",
                options: _ctx.state.departments.list,
                value: _ctx.filters_state.culpritSideId,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.culpritSideId) = $event)),
                label: "description",
                "search-by": "description",
                onRefresh: _ctx.loadDictionary
              }, null, 8, ["loading", "failed", "options", "value", "onRefresh"]),
              _createVNode(_component_the_input, {
                type: "date",
                class: "w-full",
                placeholder: "Создана от",
                value: _ctx.filters_state.fromDate,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.fromDate) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                type: "date",
                class: "w-full",
                placeholder: "Создана до",
                value: _ctx.filters_state.toDate,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.toDate) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "ID",
                value: _ctx.filters_state.id,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.id) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Номер накладной",
                value: _ctx.filters_state.invoiceNumber,
                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters_state.invoiceNumber) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                class: "w-full",
                placeholder: "Создатель жалобы клиент",
                value: _ctx.filters_state.initiator,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.initiator) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                placeholder: "Обвиняемый сотрудник",
                loading: _ctx.state.employees.is_loading,
                failed: _ctx.state.employees.is_failed,
                "error-text": "При получении списка сотрудников произошла ошибка",
                options: _ctx.state.employees.list,
                value: _ctx.filters_state.accusedEmployeeId,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.accusedEmployeeId) = $event)),
                onRefresh: _ctx.loadEmployees,
                onLoadmore: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadMoreEmployees(_ctx.state.employees.pagination.current_page + 1))),
                onSearch: _ctx.searchEmployees,
                onOptionBySearch: _ctx.unshiftFindedEmployee,
                "infinite-scroll": "",
                label: "fullName",
                "search-by": "fullName"
              }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onSearch", "onOptionBySearch"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                placeholder: "Создатель жалобы сотрудник",
                loading: _ctx.state.users.is_loading,
                failed: _ctx.state.users.is_failed,
                "error-text": "При получении списка сотрудников произошла ошибка",
                options: _ctx.state.users.list,
                value: _ctx.filters_state.initiatorId,
                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters_state.initiatorId) = $event)),
                onRefresh: _ctx.loadUsers,
                onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreUsers(_ctx.state.users.pagination.current_page + 1))),
                onSearch: _ctx.searchUsers,
                onOptionBySearch: _ctx.unshiftFindedUser,
                "infinite-scroll": ""
              }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onSearch", "onOptionBySearch"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                placeholder: "Компания",
                loading: _ctx.state.companies.is_loading,
                failed: _ctx.state.companies.is_failed,
                "error-text": "При получении списка компаний произошла ошибка",
                options: _ctx.state.companies.list,
                value: _ctx.filters_state.companyId,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters_state.companyId) = $event)),
                "search-without-refresh": "",
                onRefresh: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadCompanies(_ctx.state.companies.pagination.current_page)))
              }, null, 8, ["loading", "failed", "options", "value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "w-full mt-2",
                placeholder: "Тип",
                options: _ctx.COMPLAINT_TYPE_OPTIONS,
                value: _ctx.filters_state.categoryId,
                "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters_state.categoryId) = $event))
              }, null, 8, ["options", "value"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_the_button, {
                class: "second text small mr-2",
                loading: _ctx.state.complaints.is_loading,
                onClick: _ctx.resetFilters
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" Сброс ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              _createVNode(_component_the_button, {
                class: "primary text small",
                loading: _ctx.state.complaints.is_loading,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Поиск ")
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ], 32),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_page_title, {
              title: "Список жалоб",
              class: "mb-3"
            }),
            (
                        _ctx.state.complaints.is_failed &&
                        !_ctx.state.complaints.failure.error_state.is_cancel
                    )
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.state.complaints.is_loading,
                  text: "При получении списка жалоб произошла ошибка",
                  "error-message": _ctx.state.complaints.failure.error_state.message,
                  "error-url": _ctx.state.complaints.failure.error_state.url,
                  "error-status": _ctx.state.complaints.failure.error_state.status,
                  onRefresh: _cache[16] || (_cache[16] = ($event: any) => (_ctx.loadComplaints(_ctx.state.complaints.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                  key: 1,
                  loading: _ctx.state.complaints.is_loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_table, {
                      loading: _ctx.state.complaints.is_loading,
                      columns: _ctx.ComplaintsColumns,
                      rows: _ctx.state.complaints.list,
                      "with-limit": "",
                      "pagination-limit": _ctx.filters_state.limit,
                      "pagination-total-items": _ctx.state.complaints.pagination.total_items,
                      "pagination-current-page": _ctx.state.complaints.pagination.current_page,
                      "pagination-total-pages": _ctx.state.complaints.pagination.total_pages,
                      onChangePage: _ctx.loadComplaints,
                      onChangeLimit: _ctx.onLimitChange
                    }, {
                      td: _withCtx(({ row, column }) => [
                        (_ctx.ComplaintsIdColumns.includes(column.key) && row[column.key])
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(row[column.key].name), 1)
                            ], 64))
                          : (column.key === 'createdAt')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDate(row.createdAt)), 1)
                              ], 64))
                            : (column.key === 'id')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 2,
                                  class: "text-blue-500",
                                  to: `/complaints/${row.id}`,
                                  target: "_blank"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row.id), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                ], 64))
                      ]),
                      actions: _withCtx(({ row }) => [
                        _createVNode(_component_the_button, {
                          class: "yellow small",
                          onClick: ($event: any) => (_ctx.onUpdateComplaint(row)),
                          hint: "Согласовать"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                  ]),
                  _: 1
                }, 8, ["loading"]))
          ])
        ], 64))
  ]))
}